const ua = navigator.userAgent;
const isIOS = /iPhone|iPad|iPod/.test(ua);

if (window.location.pathname.startsWith("/ios")) {
  if (!isIOS) {
    document.body.innerHTML = `
      <div style="padding:24px;text-align:center">
        <h2>SmartReadGo iOS Beta</h2>
        <p>This beta is available only on iPhone.</p>
        <p>Please open this link on an iPhone.</p>
      </div>
    `;
    throw new Error("Blocked non-iOS access");
  }
}

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
if (
  "serviceWorker" in navigator &&
  window.location.pathname.startsWith("/ios")
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/ios/sw.js");
  });
}